/** @format */

export default {
	SET_CHARGE: 'SET_CHARGE',
	SET_ERROR_FOR_CHARGE: 'SET_ERROR_FOR_CHARGE',
};
